export function groupAttributeFn(key: string, title?: string) {
  return title?.concat("s");
}
